const get_started = {
    page_title: 'Get started',
    title: 'Something to help you succeed',
    subtitle: 'A few things you can do to quickly get value of Logto',
    develop: {
        title: 'Develop: Take 5 minutes to integrate your app',
        title_cloud: 'Develop: Securely integrate your app in minutes',
        subtitle_cloud: 'Or take 5 minutes to integrate your app with our pre-built SDKs and tutorials.',
        try_mcp: 'Try one-prompt integration with MCP',
    },
    customize: {
        title: 'Customize: Deliver a great sign-in experience',
        preview: {
            title: 'Check the live preview of the sign-in experience you just customized',
            subtitle: 'Try Logto sign-in experience now to see how it works',
        },
        connector: {
            title: 'Add more connectors to support more social sign-in methods',
            subtitle: 'Try passwordless sign in and enable a secure and frictionless experience for your customers',
        },
        continue_customizing: 'Continue customizing',
        try_now: 'Try now',
        add_more: 'Add more',
    },
    secure: {
        title: 'Secure: Protect your resources',
    },
    manage: {
        title: 'Manage: Define access control for your product and users',
        rbac: {
            title: 'Add role-based access control to protect your resources',
            subtitle: 'Control your resource through scalable role authorization for diverse use cases.',
        },
        create_roles: 'Create roles',
    },
    convert_to_production: {
        card_title: 'Ready to go live? Don’t forget to launch your production setup!',
        title: "Don't keep your project stuck in dev mode",
        subtitle: "You're using a dev tenant for free testing. To go live, create or convert to a production tenant. Need something custom? <a>Contact us</a>",
        convert_button: 'Convert to production tenant',
    },
    oss_cloud: {
        try: {
            title: 'Skip the ops work — try Logto Cloud free',
            badge: 'Recommended',
            description: 'Get a fully managed Logto with zero maintenance — plus MCP-powered quick integration, multi-tenant support, team collaboration, and all premium features included. Free to start, no credit card required.',
            action: 'Explore Logto Cloud',
        },
        private_cloud: {
            title: 'Need compliance or custom deployment?',
            card_title: 'Private cloud',
            description: 'Get a dedicated Logto instance with full data isolation, custom domain, and SLA guarantees. Perfect for enterprises with strict data residency or compliance requirements. We handle the infrastructure so you can focus on your product.',
        },
        sidebar: {
            title: 'Focus on building, not hosting.',
            description: 'Let Logto Cloud handle auth infrastructure for you.',
            action: 'Try Logto Cloud',
        },
    },
    view_all: 'View all →',
};
export default Object.freeze(get_started);
